import React from 'react';
import PropTypes from 'prop-types';

import { formatYear } from '@zr/common/js/profile/formatters';
import ExpandableText from '@zr/components/ExpandableText';
import { getSortedSection } from '@zr/jobseeker-public/apps/jobseeker-profile/utilities';

export function LicensesCertsSection({ headingLevel, liccerts }) {
  const Heading = headingLevel;

  return (
    <section className="licenses_certifications employer_profile_section">
      <Heading className="title">Certificates and Licenses</Heading>
      <ol>
        {getSortedSection(liccerts).map((liccert, index) => (
          <li className="item" key={`${index.toString()}licert`}>
            <h3 className="item_title">
              {liccert.name}
            </h3>
            <div className="subheadlines">
              <h4 className="subheadline">
                {liccert.issued_date && (
                  <span className="dates">
                    <time className="subheadline">
                      {formatYear(liccert.issued_date)}
                    </time>
                  </span>
                )}
                <span className="subhead" title={liccert.issuing_authority}>
                  {liccert.issuing_authority}
                </span>
              </h4>
            </div>
            {!!liccert.description && <ExpandableText className="description" text={liccert.description} />}
          </li>
        ))}
      </ol>
    </section>
  );
}

LicensesCertsSection.propTypes = {
  headingLevel: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']).isRequired,
  liccerts: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    issued_date: PropTypes.string,
    issuing_authority: PropTypes.string,
    description: PropTypes.string,
  })).isRequired,
};

export default LicensesCertsSection;
